import { Collapse, Input, Button, message } from "antd";
import { FeaturedI } from "@/services/Articles/updateArticle";
import { useState } from "react";

type FeaturedProps = {
    featured: FeaturedI[];
    className?: string;
};

export const Featured = ({ featured, className }: FeaturedProps) => {
    if (!featured || featured.length === 0) return null;

    const renderContent = (f: FeaturedI) => {
        if (!f.items || f.items.length === 0) return null;

        switch (f.type) {

            case "normal-type":
                return (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                        {f.items.map((item, idx) => (
                            <p
                                key={idx}
                                style={{
                                    padding: "2px 6px",
                                    backgroundColor: "#eee",
                                    borderRadius: "4px",
                                }}
                            >
                                {item}
                            </p>
                        ))}
                    </div>
                );

            default:
                return (
                    <ul style={{ paddingLeft: 10, }}>
                        {f.items.map((item, idx) => (
                            <li
                                key={idx}>
                                <p style={{ fontSize: '13px' }} key={idx}>
                                    {item}
                                </p>
                            </li >
                        ))
                        }
                    </ul >
                );
        }
    };

    const items = featured.map((f, index) => ({
        key: String(index),
        label: (
            <h3 style={{ fontSize: "14px", color: "var(--color-text)", }}>
                {f.title}
            </h3>
        ),
        children: renderContent(f),
    }));

    return (
        <div
            className={className}
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: "100%",
                borderRadius: "5px",
                margin: '30px 0px 20px 0px',
                gap: '20px',
            }}
        >
            <div
            >
                <Collapse
                    style={{ backgroundColor: "#3f51b51a", }}
                    defaultActiveKey={["0"]}
                    expandIcon={({ isActive }) => (
                        <i
                            className="fi fi-br-angle-right"
                            style={{
                                transform: `rotate(${isActive ? 90 : 0}deg)`,
                                color: "grey",
                                transition: "transform 0.2s",
                            }}
                        />
                    )}
                    items={items}
                />
            </div>
            <div
                style={{ marginTop: 'auto' }}
            >
                <EmailSubscribe />
            </div>
        </div >
    );
};


export const EmailSubscribe = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    // basit e-mail regex
    const validateEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubscribe = () => {
        if (!validateEmail(email)) {
            messageApi.error("Lütfen geçerli bir e-mail adresi girin!");
            return;
        }

        setLoading(true);

        // fake async request (2 saniye bekle)
        setTimeout(() => {
            setLoading(false);
            messageApi.success("Kayıt başarılı! 🎉");
            setEmail(""); // input sıfırla
        }, 2000);
    };

    return (
        <div
            style={{
                backgroundColor: "var(--color-bg-secondary)",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
        >
            {contextHolder}
            <h3 style={{ fontSize: "18px", color: "var(--color-text)" }}>
                📧 E-mail Kayıt
            </h3>
            <p style={{ margin: "8px 0 16px 0", color: "grey", fontSize: "14px" }}>
                Yeni yayınlanan makalelere anında erişmek için abone olun. <br />
                <b>Kayıt ücretsizdir.</b>
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Input
                    placeholder="E-mail adresiniz"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Button type="primary" onClick={handleSubscribe} loading={loading}>
                    {loading ? "Kaydediliyor..." : "Kayıt Ol"}
                </Button>
            </div>
        </div>
    );
};
